module.exports = __webpack_public_path__ + "static/media/redback.0647f384.png";